import React, { useEffect, useState } from 'react'
import {
    FilterBetweenDatesInner
} from '@Knowledge-OTP/znk-ui-components'
import ShortcutFilter from './Shortcut'
import moment from 'moment-timezone'

const InnerFilter = (props) => {
    const { filters = [], onCancel = () => { }, onApply = () => { }, style = {} } = props
    const [dates, setDates] = useState([])
    const [start, end] = dates

    useEffect(() => {
        if (filters[0] !== start || filters[1] !== end) {
            setShortcut(null)
            setDates(filters)
        }
        //eslint-disable-next-line
    }, [filters])
    const [shortcut, setShortcut] = useState(null)

    const applyShortcut = (key) => {
        let newStart = start
        let newEnd = end
        switch (key) {
            case 'today':
                newStart = moment().startOf('day')
                newEnd = moment().endOf('day')
                break
            case 'yesterday':
                newStart = moment().subtract(1, 'day').startOf('day')
                newEnd = moment().subtract(1, 'day').endOf('day')
                break
            case 'month':
                newStart = moment().startOf('month')
                newEnd = moment().endOf('month')
                break
            case 'last-month':
                newStart = moment().subtract(1, 'month').startOf('month')
                newEnd = moment().subtract(1, 'month').endOf('month')
                break
            case 'last-3-months':
                newStart = moment().subtract(4, 'month').startOf('month')
                newEnd = moment().subtract(1, 'month').endOf('month')
                break
            case 'week-7':
                newStart = moment().subtract(1, 'week').startOf('day')
                newEnd = moment().endOf('day')
                break
            case 'last-week':
                newStart = moment().subtract(1, 'isoWeek').startOf('isoWeek')
                newEnd = moment().subtract(1, 'isoWeek').endOf('isoWeek')
                break
            default:
        }

        setShortcut(key)
        setDates([newStart.toISOString(), newEnd.toISOString()])
        //aplica filtro y cierra dropdown
        onApply([newStart.toISOString(), newEnd.toISOString()])
    }
    return (
        <div className={`d-flex flex-column p-0`} style={{ maxWidth: '250px', ...style }}>
            <div className={`d-flex flex-row w-100 mb-1 p-2`}>
                <ShortcutFilter
                    isSelected={shortcut === 'today'}
                    onClick={() => {applyShortcut('today')}}
                    label={`Today`}
                />
                <ShortcutFilter
                    isSelected={shortcut === 'yesterday'}
                    onClick={() => {applyShortcut('yesterday')}}
                    label={`Yesterday`}
                />
            </div>
            <div className={`d-flex flex-row w-100 mb-1 p-1`}>

                <ShortcutFilter
                    isSelected={shortcut === 'week-7'}
                    onClick={() => {applyShortcut('week-7')}}
                    label={`Last 7 days`}
                />
                <ShortcutFilter
                    isSelected={shortcut === 'month'}
                    onClick={() => {applyShortcut('month')}}
                    label={`This month`}
                />
            </div>
            <div className={`d-flex flex-row w-100 mb-0 p-1`}>

                <ShortcutFilter
                    isSelected={shortcut === 'last-month'}
                    onClick={() => {applyShortcut('last-month')}}
                    label={`Last month`}
                />
                <ShortcutFilter
                    isSelected={shortcut === 'last-3-months'}
                    onClick={() => {applyShortcut('last-3-months')}}
                    label={`Last 3 months`}
                />
            </div>
            <FilterBetweenDatesInner
                dates={dates}
                strings={{
                    from: 'From',
                    to: 'To',
                    buttonCancel: 'Cancel',
                    buttonApply: 'Apply'
                }}
                setDates={(newDates) => {
                    // FilterBetweenDatesInner sends [] on Cancel and a two-item
                    // array on Apply, even when both dates are empty.
                    if (newDates.length === 0) {
                        onCancel()
                        return
                    }
                    setShortcut(null)
                    setDates(newDates)
                    onApply(newDates)
                }}
            />
        </div>
    )
}

export default InnerFilter
